import PropTypes from 'prop-types';
import React from 'react';
import { compose, pure } from 'recompose';
import withSpinner from '../withSpinner';
import withTutorial from '../withTutorial';
import { Body, Head, Header, Table, listProvider, withActiveItem } from '../list';
import fullName from '../../common/utils/fullName';
import ErrorMessage from '../ErrorMessage';

import './SimulationTable.scss';
import ListItemTopinvest from './ListItemTopinvest';

const NoSimuMessage = () => (
    <ErrorMessage>
        <div>
            Pour créer votre première simulation TopInvest associée à ce e-RIP, cliquez sur le (+) en bas à droite de cette page.
        </div>
    </ErrorMessage>
);

const SimulationTopinvestTable = ({ rip, items }) => (
    <Table>
        <Head>
            <th />
            <Header sortProperty="Nom" text={`Simulations de ${fullName(rip)}`} />
            <Header sortProperty="LibelleTypeSimulation" text="Type" />
            <Header sortProperty="IntituleFoyerFiscal" text="Foyer fiscal" />
            <Header sortProperty="DateCreation" text="Date de création" />
            <Header sortProperty="DateModification" text="Dernière modification" />
            <th />
        </Head>
        <Body>
            {items.map((item) => (
                <ListItemTopinvest
                    key={item.IdSimulation}
                    rip={rip}
                    item={item}
                />
            ))}
        </Body>
    </Table>
);

SimulationTopinvestTable.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        IdSimulation: PropTypes.number,
    })).isRequired,
    rip: PropTypes.shape({}).isRequired,
};

export default compose(
    listProvider({
        sorts: {
            DateCreation: { initialOrder: 'desc', default: true },
            Nom: { initialOrder: 'asc' },
            LibelleTypeSimulation: { initialOrder: 'asc' },
            IntituleFoyerFiscal: { initialOrder: 'asc' },
            DateModification: { initialOrder: 'desc' },
        },
        name: 'simulationTopinvest',
        type: 'simulationTopinvest',
        filter: ({ session, rip }) => (item) => session.permissions.mayReadSimulation(item, rip),
        criteria: ({ rip: { id } }) => ({ ripId: id }),
    }),
    withSpinner,
    withTutorial(NoSimuMessage),
    withActiveItem,
    pure,
)(SimulationTopinvestTable);
